/**
 * Internal dependencies
 */
import FormItem from '@/components/FormItem';
import { OfferFormValues } from '@/offer-form/types';

const OfferFormItem = FormItem<OfferFormValues>;

export default OfferFormItem;
